<template>
  <v-data-table
    :headers="actualHeaders"
    :items="routes"
    class="elevation-1"
    hide-actions
    no-data-text="No hay informacion que mostrar"
  >
    <template v-slot:items="props">
      <td>{{ props.item.real_date |formatDateWithoutTimeZone }}</td>
      <td><router-link :to="routeLink(props.item)">{{ props.item.description }}</router-link> </td>
      <td>{{ props.item.name ? props.item.name : '- -'  }} </td>
      <template v-if="currentBag.type === 'HIGH'" >
        <td>{{ props.item.pounds }}</td>
        <td>{{ getContentToDisplay(props.item) }}</td>
        <td v-if="props.item.summary.top">{{ props.item.summary.top.tops | currency('') }}</td>
        <td v-else>0.00</td>
        <td v-if="props.item.summary.top">{{ props.item.summary.top.pieces_per_kilo | currency('') }}</td>
        <td v-else>0.00</td>
      </template>
      <template v-if="currentBag.type === 'LOW'">
        <td>{{ getContentToDisplay(props.item) }}</td>
      </template>
      <template v-if="currentBag.type === 'METAL'">
        <td>{{ getformatedMetalValues(props.item, 'IL') }}</td>
        <td>{{ getformatedMetalValues(props.item, 'IM') }}</td>
        <td>{{ getformatedMetalValues(props.item, 'IS') }}</td>
        <td>{{ getformatedMetalValues(props.item, 'LL') }}</td>
        <td>{{ getformatedMetalValues(props.item, 'LM') }}</td>
        <td>{{ getformatedMetalValues(props.item, 'LS') }}</td>
      </template>
      <td>{{ statusDescription(props.item.status) }}</td>
      <td class="justify-center layout px-0">
        <v-icon
          v-if="props.item.status === 'OPEN'"
          small
          class="mr-2"
          @click="closeRoute(props.item)"
        >
          lock
        </v-icon>
        <v-icon
        v-if="props.item.status === 'CLOSE'"
          small
          @click="openRoute(props.item)"
        >
          lock_open
        </v-icon>
      </td>
    </template>
  </v-data-table>
</template>
<script>
export default {
  props: ['routes', 'currentBag'],
  data() {
    return {
      higHeaders: [
        { text: 'Fecha', value: 'created_on'},
        { text: 'Ruta', value: 'description' },
        { text: 'Operador', value: 'name' },
        { text: 'Libras', value: 'real_pieces' },
        { text: 'Piezas'},
        { text: 'Tops'},
        { text: 'Piezas Por Kilo'},
        { text: 'Estado', value: 'status' },
        { text: 'Operaciones', sortable: false },
      ],
      lowHeaders: [
        { text: 'Fecha', value: 'created_on'},
        { text: 'Ruta', value: 'description' },
        { text: 'Operador', value: 'name' },
        { text: 'Piedra'},
        { text: 'Estado', value: 'status' },
        { text: 'Operaciones', sortable: false },
      ],
      metalHeaders: [
        { text: 'Fecha', value: 'created_on'},
        { text: 'Ruta', value: 'description' },
        { text: 'Operador', value: 'name' },
        { text: 'Imp. Gr.', sortable: false },
        { text: 'Imp. Med.', sortable: false},
        { text: 'Imp. Ch.', sortable: false},
        { text: 'Loc. Gr.', sortable: false },
        { text: 'Loc. Med.', sortable: false},
        { text: 'Loc. Ch.', sortable: false},
        { text: 'Estado', value: 'status' },
        { text: 'Operaciones', sortable: false },
      ],
      headers: [
        { text: 'Fecha', value: 'created_on'},
        { text: 'Ruta', value: 'description' },
        { text: 'Operador', value: 'name' },
        { text: 'Libras', value: 'real_pieces' },
        { text: 'Piedra'},
        { text: 'Tops'},
        { text: 'Piezas Por Kilo'},
        { text: 'Estado', value: 'status' },
        { text: 'Operaciones', sortable: false },
      ],
    };
  },
  computed: {
    actualHeaders() {
      if (this.currentBag.type === 'HIGH') {
        return this.higHeaders;
      } else if (this.currentBag.type === 'LOW') {
        return this.lowHeaders;
      } else if (this.currentBag.type === 'METAL') {
        return this.metalHeaders;
      }
      return this.headers;
    },
  },
  methods: {

    getContentToDisplay(route) {
      if (this.currentBag.type === 'LOW') {
        return route.dust;
      } else if (this.currentBag.type === 'HIGH') {
        if (route.summary && route.summary.catalyst) {
          return `${route.summary.catalyst.pieces} (${route.summary.catalyst.real_pieces})`;
        }
      }
      return '--';
    },
    statusDescription(status) {
      const descriptions = {
        OPEN: 'Abierto',
        CLOSE: 'Cerrado',
      };
      return descriptions[status];
    },

    getformatedMetalValues(item, type) {
      if(!item.summary || !item.summary.metal){
        return [0,0]
      }
      let result = [];
      if (type === 'IL') {
        result = this.getImportedLargeValues(item);
      }
      if (type === 'IM') {
        result = this.getImportedMediumValues(item);
      }
      if (type === 'IS') {
        result = this.getImportedSmallValues(item);
      }
      if (type === 'LL') {
        result = this.getLocalLargeValues(item);
      }
      if (type === 'LM') {
        result = this.getLocalMediumValues(item);
      }
      if (type === 'LS') {
        result = this.getLocalSmallValues(item);
      }
      return `${result[0]} (${result[1]})`;
    },

    getImportedLargeValues(item) {
      const pieces = item.summary.metal.ILW
        + item.summary.metal.ILT
        + item.summary.metal.ILH
        + item.summary.metal.ILQ;
      const realPieces = item.summary.metal.ILW * 1
        + item.summary.metal.ILT * 0.75
        + item.summary.metal.ILH * 0.50
        + item.summary.metal.ILQ * 0.25;
      return [pieces, realPieces];
    },
    getImportedMediumValues(item) {
      const pieces = item.summary.metal.IMW
        + item.summary.metal.IMT
        + item.summary.metal.IMH
        + item.summary.metal.IMQ;
      const realPieces = item.summary.metal.IMW * 1
        + item.summary.metal.IMT * 0.75
        + item.summary.metal.IMH * 0.50
        + item.summary.metal.IMQ * 0.25;
      return [pieces, realPieces];
    },
    getImportedSmallValues(item) {
      const pieces = item.summary.metal.ISW
        + item.summary.metal.IST
        + item.summary.metal.ISH
        + item.summary.metal.ISQ;
      const realPieces = item.summary.metal.ISW * 1
        + item.summary.metal.IST * 0.75
        + item.summary.metal.ISH * 0.50
        + item.summary.metal.ISQ * 0.25;
      return [pieces, realPieces];
    },
    getLocalLargeValues(item) {
      const pieces = item.summary.metal.LLW
        + item.summary.metal.LLT
        + item.summary.metal.LLH
        + item.summary.metal.LLQ;
      const realPieces = item.summary.metal.LLW * 1
        + item.summary.metal.LLT * 0.75
        + item.summary.metal.LLH * 0.50
        + item.summary.metal.LLQ * 0.25;
      return [pieces, realPieces];
    },
    getLocalMediumValues(item) {
      const pieces = item.summary.metal.LMW
        + item.summary.metal.LMT
        + item.summary.metal.LMH
        + item.summary.metal.LMQ;
      const realPieces = item.summary.metal.LMW * 1
        + item.summary.metal.LMT * 0.75
        + item.summary.metal.LMH * 0.50
        + item.summary.metal.LMQ * 0.25;
      return [pieces, realPieces];
    },
    getLocalSmallValues(item) {
      const pieces = item.summary.metal.LSW
        + item.summary.metal.LST
        + item.summary.metal.LSH
        + item.summary.metal.LSQ;
      const realPieces = item.summary.metal.LSW * 1
        + item.summary.metal.LST * 0.75
        + item.summary.metal.LSH * 0.50
        + item.summary.metal.LSQ * 0.25;
      return [pieces, realPieces];
    },
    async closeRoute(route) {
      const result = await closeRoute(route.id);
      route.status = result.data.status;
    },
    async openRoute(route) {
      const result = await openRoute(route.id);
      route.status = result.data.status;
    },
    routeLink(route) {
      return `/batch/${this.currentBag.batch_id}/bag/${this.currentBag.id}/route/${route.id}`;
    },
  },
};
</script>
